module.exports = __webpack_public_path__ + "static/media/derecho-penal.dd7054d1.jpg";